import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const CouponDescription = props => {
  const { coupon } = props;
  const { t } = useTranslation();

  return (
    <Typography variant="h6">
      {coupon.Name} - {coupon.DiscountPercentage}% for {coupon.DurationMonth} months
    </Typography>
  );
};

CouponDescription.propTypes = {
  coupon: PropTypes.object.isRequired,
};

export default CouponDescription;